export function useApiErrors() {
  function toMessage(error: unknown): {
    text: string;
    color: 'success' | 'error' | 'info';
  } {
    const status = (error as { response?: { status?: number } })?.response
      ?.status;
    const code = (error as { code?: string })?.code;

    if (status === 400)
      return { text: 'Invalid username or password', color: 'error' };
    if (status === 403)
      return {
        text: 'Access denied. You do not have permission to log in.',
        color: 'error',
      };
    if (code === 'ERR_NETWORK')
      return { text: 'Network error. Try again.', color: 'error' };
    if (status !== undefined && status >= 500)
      return { text: 'Server error. Please try again later.', color: 'error' };

    return { text: 'Something went wrong. Please try again.', color: 'error' };
  }

  return { toMessage };
}
